import React from 'react';

interface IconProps {
  component: any;
}

const Icon: React.FC<IconProps> = ({ component: Component }) => {
  return <Component />;
};

export default Icon;
